/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */

import moment from "moment-timezone";
import formatDistance from "date-fns/formatDistance";

// get active alerts
export const getActiveAlerts = async (alerts: any[]) => {
  const activeAlerts: any[] = alerts.filter((alert: any) => {
    return alert?.isCleared === false;
  });
  return activeAlerts;
};


//display time passed from now
export const customFormatDate = (date: any, elapsedFrom : any) => {
  let forDate = formatDistance(new Date(date), new Date(elapsedFrom));
  let arrayNumbers = forDate.split(" ");
  let firstNumber = arrayNumbers[0];
  let timeUnit = '';
  
  let time = moment.utc(date);
  var duration = moment.duration(moment.utc(elapsedFrom).diff(time));
  
  // Helper function to get the proper time unit suffix
  const getTimeUnitSuffix = (timeWord: string, number: string | number) => {
    const num = parseInt(number.toString());
    if (timeWord?.includes('second')) {
      return num === 1 ? 'sec' : 'sec';
    } else if (timeWord?.includes('minute')) {
      return num === 1 ? 'mins' : 'mins';
    } else if (timeWord?.includes('hour')) {
      return num === 1 ? 'hr' : 'hrs';
    } else if (timeWord?.includes('day')) {
      return num === 1 ? 'day' : 'days';
    } else if (timeWord?.includes('month')) {
      return num === 1 ? 'month' : 'months';
    } else if (timeWord?.includes('year')) {
      return num === 1 ? 'year' : 'years';
    }
    return timeWord?.charAt(0) || '';
  };
  
  //if formatDistance return about
  if (firstNumber === "about") {
    firstNumber = arrayNumbers[1];
    timeUnit = getTimeUnitSuffix(arrayNumbers[2], firstNumber);
    let result = firstNumber + timeUnit;
    return result;
    //if formatDistance return less than a minute
  } else if (forDate === "less than a minute") {
    var second = duration.asSeconds();
    var roundOfSecond = Math.round(second);
    var result = roundOfSecond + "sec";
    return result;
    //if formatDistance return none of above
  } else {
    firstNumber = arrayNumbers[0];
    timeUnit = getTimeUnitSuffix(arrayNumbers[1], firstNumber);
    let result = firstNumber + " " + timeUnit;
    return result;
  }
};
